import { TenantSubscription } from '../entities';
import * as Enumerable from 'linq';

export const TenantPlanFeatures = {
    [TenantSubscription.Core]: [TenantSubscription.Core],
    [TenantSubscription.Professional]: [TenantSubscription.Core, TenantSubscription.Professional],
    [TenantSubscription.Enterprise]: [TenantSubscription.Core, TenantSubscription.Professional, TenantSubscription.Enterprise],
    [TenantSubscription.Developer]: [TenantSubscription.Core, TenantSubscription.Professional, TenantSubscription.Enterprise, TenantSubscription.Custom],
} as const;

export interface TenantPlan {
    subscription: TenantSubscription;
    features: {
        [key: string]: boolean;
    },
    addons: {
        [key: string]: boolean;
    }
}

export function tenantFeatureEnabled(plan: TenantPlan, feature: string): boolean {
    const hasFeature = Enumerable
        .from(Object.keys(plan?.features))
        .any(key => plan[key] === true && key === feature);

    if (hasFeature)
        return true;

    return Enumerable
        .from(Object.keys(plan?.addons))
        .any(key => plan.addons[key] === true && key === feature);
}